const globalAllert = new Event('callAllert')
const errorCallback = ERR_MSG => {
  globalAllert.messageContent = ERR_MSG
  globalAllert.callback = () => {
    localStorage.removeItem('PI_TOKEN')
    localStorage.removeItem('PI_UID')
    location.reload()
  }

  window.dispatchEvent(globalAllert)
  throw ERR_MSG
}

/**
 * 進入商城時將GRANT_CODE傳給後端取得ACCESS_TOKEN。
 * @param {string} GRANT_CODE - 經Pi oAuth所取得的GrantCode
 */
export async function piGetAccessToken(GRANT_CODE) {
  try {
    const res = await api.getPiAccessToken(GRANT_CODE)
    res.data.active_time = Date.now() + res.data.expires_in * 1000
    localStorage.setItem('PI_TOKEN', JSON.stringify(res.data))
    return res
  } catch (error) {
    errorCallback('AccessToken取得失敗')
  }
}

/**
 * 取得使用者在PI錢包的UID,用來取得user_info, points
 */
export async function piGetUid() {
  try {
    console.log('piGetUid')
    const res = await api.getPiMe(
      JSON.parse(localStorage.getItem('PI_TOKEN')).access_token
    )
    localStorage.setItem('PI_UID', res.data.user_id)
    return res.data.user_id
  } catch (error) {
    errorCallback('取得使用者失敗)')
    throw error
  }
}

/**
 * @param {Number} times - 第幾次
 * 取得使用者在PI錢包的POINTS
 */
export async function getPiUserPoint(times = 0) {
  try {
    console.log('getPiUserPoint')
    const res = await api.getPiUserPoint(
      JSON.parse(localStorage.getItem('PI_TOKEN')).access_token,
      localStorage.getItem('PI_UID')
    )
    localStorage.setItem('PI_POINTS', res.data.total_points)
    return res.data.total_points
  } catch (error) {
    if (times < 3) {
      times += 1
      getPiUserPoint(times)
    } else {
      // errorCallback('取得點數失敗')
      throw error
    }
  }
}

/**
 * 更新token
 */
export async function refreshPiToken() {
  try {
    const res = await api.getPiRefreshToken(
      JSON.parse(localStorage.getItem('PI_TOKEN')).refresh_token
    )
    res.data.active_time = Date.now() + res.data.expires_in * 1000
    localStorage.setItem('PI_TOKEN', JSON.stringify(res.data))
    return true
  } catch (error) {
    // errorCallback('更新TOKEN失敗' + '(' + error + ')')
    throw error
  }
}
